export default function thousandSeparator(numeric = 0) {
  return numeric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
